import { actionTypes } from "../constants/action-types";

export const setLogoUrl =(payload)=>{
    return {
        type : actionTypes.SET_LOGO_URL,
        payload :payload
    }

}

